import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";

const ConfirmDialog = ({
    open,
    title,
    message,
    onConfirm,
    onClose,
    confirmText = "Confirm",
    cancelText = "Cancel",
    loading = false,
    disableConfirm = false,
    error = "",
    confirmColor = "primary",
    compact = false,
    hideCancel = false,
}) => {
    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: compact
                    ? {
                        width: { xs: "calc(100% - 24px)", sm: 560, md: 620 },
                        maxWidth: { xs: "calc(100% - 24px)", sm: 620 },
                        maxHeight: { xs: "calc(100% - 24px)", sm: "calc(100% - 64px)" },
                    }
                    : undefined,
            }}
        >
            <DialogTitle>{title}</DialogTitle>

            <DialogContent dividers>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                {typeof message === "string" ? (
                    <Typography>{message}</Typography>
                ) : (
                    <Box>{message}</Box>
                )}
            </DialogContent>

            <DialogActions
                sx={{
                    px: 3,
                    py: 2,
                    position: { xs: "sticky", sm: "static" },
                    bottom: 0,
                    zIndex: 1,
                    bgcolor: "background.paper",
                    borderTop: { xs: "1px solid", sm: "none" },
                    borderColor: "divider",
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: 1,
                }}
            >
                {!hideCancel && (
                    <Button
                        onClick={onClose}
                        fullWidth
                        variant="outlined"
                        disabled={loading}
                    >
                        {cancelText}
                    </Button>
                )}

                <Button
                    variant="contained"
                    color={confirmColor}
                    onClick={onConfirm}
                    fullWidth
                    disabled={loading || disableConfirm}
                >
                    {loading ? "Processing..." : confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
